<template>
    <div id="popup" @touchmove.prevent>
        <div class="popBox">
            <div :style="{width:pops.iconWidth+'px',height:pops.iconHeight+'px',margin:pops.iconMargin}">
                <img :src="pops.icons" alt="" :style="{width:pops.iconWidth+'px',height:pops.iconHeight+'px'}" v-if="pops.icons">
            </div>
            <div class="title">
                <div v-if="pops.tits1">{{pops.tits1}}</div>
                <div v-if="pops.tits2">{{pops.tits2}}</div>
            </div>
            <div class="contents" v-if="pops.conts">{{pops.conts}}<span>{{pops.contsRed}}</span></div>
            <div class="btn" :style="{marginTop:pops.btnMarginTop+'px'}" @click="childMethod()">{{pops.btns}}</div>

            <img :src="pops.closeImg" alt="" v-if="pops.closeImg" class="closed" @click="closeBox">
        </div>
    </div>
</template>

<script>
    export default {
        props:['pops'],
        components:{

        },
        data() {
            return {
                
            }
        },
        methods: {
            childMethod:function(){
                this.$emit('fatherMethod');
            },

            closeBox:function(){
                this.$emit('closed');
            }
        },
    }
</script>

<style lang="less" scoped>
    #popup{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.5);
        .popBox{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width:200px;
            background:rgba(255,255,255,1);
            border-radius:8px;
            padding: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                margin: 11px 0;
                font-size:15px;
                font-weight:bold;
                color:rgba(51,51,51,1);
                display: flex;
                flex-direction: column;
                align-items: center;
                line-height: 22px;
            }
            .contents{
                font-size:14px;
                color:rgba(102,102,102,1);
                line-height:20px;
                text-align: center;
                span{
                    color: #EB3C45;
                }
            }
            .btn{
                width:160px;
                height:38px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:18px;
                font-size:16px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:38px;
                text-align: center;
            }
            .closed{
                width: 12px;
                height: 12px;
                position: absolute;
                right: 20px;
                top: 20px;
            }
        }
    }
</style>